let DEFINE_KEY = {
  ALERT_CONFIG:{
    ALERT_CLOSE_TIME:2000
  }
}
var LeCompTool = {
  _idSeed:{
    id:90000,
    newId:()=>{
        return LeCompTool._idSeed.id++;
    }
  }
}
var _le_alert = {
    showTip:function(msg){
      let zIndex = LeCompTool._idSeed.newId();
      let parentDiv = $("<div style='z-index:"+zIndex+";top:50%;opacity:0;width:80%;text-align:center;' class='le_alert content'></div>");
      let html = "<div class='tipBox' style='opacity:0.9;display:inline-block;'>";
      html += "<p>"+msg+"</p>";
      html += "</div>";
      $(parentDiv).append($(html));
      $("body").append($(parentDiv));
      $(parentDiv).animate({top:'50%',opacity:1},500,()=>{
        setTimeout(()=>{
            $(parentDiv).animate({top:'50%',opacity:0,'z-index':0},500,()=>{
                $(parentDiv).remove();
            })
        },DEFINE_KEY.ALERT_CONFIG.ALERT_CLOSE_TIME)
      })
    },
    showConfirm:function(obj){
        let zIndex = LeCompTool._idSeed.newId();
        let parentDiv = $('<div style="z-index:'+zIndex+'" class="le_alert MsgAlertBox"></div>');
        let title = ""
        let content = ""
        if(obj.content){
          content = '<div class="content">'+obj.content+'</div>';
          title = '<h5>'+obj.title+'</h5>';
        }else{
          title = '<h5 class="le_align_center">'+obj.title+'</h5>'
        }
        let html ='<div class="Alertcontent">'+
                  '<div class="msgContent clearfix">'+  title +  content + '<div class="alert_btnGroup">'+
                  '<span class="btn cancel" tag="le-show-confirm-close">'+obj.cancelText+'</span>'+
                  '<span class="btn confirm" tag="le-show-confirm-ok">'+obj.confirmText+'</span>'+
                  '</div>'+
                  '</div>';
        $(parentDiv).append($(html));
        $("body").append($(parentDiv));
        $(".MsgAlertBox").show();

        $("body").off("click","i[tag=le-show-confirm-close]").on("click","i[tag=le-show-confirm-close]",function(){
            $(this).parents("div.MsgAlertBox").remove();
        })
        $("body").off("click",'span[tag=le-show-confirm-close]').on("click","span[tag=le-show-confirm-close]",function(){
            $(this).parents("div.MsgAlertBox").remove();
            obj.cancel &&  obj.cancel();
        })
        $("body").off("click",'span[tag=le-show-confirm-ok]').on("click","span[tag=le-show-confirm-ok]",function(){
          obj.confirm &&  obj.confirm();
          $(this).parents("div.MsgAlertBox").remove();
        })
    }
}

export default _le_alert;